
// import React, { useState } from "react";
// import { FaSort, FaFilter } from "react-icons/fa";
// import { useNavigate } from "react-router-dom";
// import SortBy from "./SortBy"; // Import the SortBy component

// const SortAndFilter = () => {
//   const navigate = useNavigate();
//   const [formData, setFormData] = useState({
//     sortBy: "",
//     filter: "",
//   });

//   const [isSortByOpen, setIsSortByOpen] = useState(false); // Manage the modal visibility

//   const handleSortClick = () => {
//     setIsSortByOpen(true); // Open the SortBy modal
//   };

//   const handleFilterClick = () => {
//     navigate("/date");
//   };

//   return (
//     <div className="flex items-center justify-center gap-36 w-full p-4 bg-white border  shadow-sm">
//       {/* Sort By Section */}
//       <div
//         className="flex items-center gap-2 cursor-pointer"
//         onClick={handleSortClick} // Open SortBy modal on click
//       >
//         <FaSort className="text-xl text-black" />
//         <label htmlFor="sort" className="text-black font-medium">
//           SORT BY
//         </label>
//       </div>

//       {/* Filter Section */}
//       <div
//         className="flex items-center gap-2 cursor-pointer"
//         onClick={handleFilterClick}
//       >
//         <FaFilter className="text-xl text-black" />
//         <label htmlFor="filter" className="text-black font-medium">
//           FILTER
//         </label>
//       </div>

//       {/* Render the SortBy modal if it's open */}
//       {isSortByOpen && <SortBy closeModal={() => setIsSortByOpen(false)} />}
//     </div>
//   );
// };

// export default SortAndFilter;


import React, { useState } from "react";
import { FaSort, FaFilter } from "react-icons/fa";
import MDateTimeFilter from "../MontlyRental/MDateTimeFilter";
import MSortBy from "./MSortBy"; 

const MSortAndFilter = () => {
  const [isSortByOpen, setIsSortByOpen] = useState(false); // Manage the SortBy modal visibility
  const [isFilterOpen, setIsFilterOpen] = useState(false); // Manage the DateTimeFilter modal visibility

  const handleSortClick = () => {
    setIsSortByOpen(true); // Open the SortBy modal
  };

  const handleFilterClick = () => {
    setIsFilterOpen(true); // Open the DateTimeFilter modal
  };

  const closeFilterModal = () => {
    setIsFilterOpen(false); // Close the DateTimeFilter modal
  };

  return (
    <div className="flex items-center justify-center gap-36 w-full p-4 bg-white border shadow-sm">
      {/* Sort By Section */}
      <div
        className="flex items-center gap-2 cursor-pointer"
        onClick={handleSortClick} // Open SortBy modal on click
      >
        <FaSort className="text-xl text-black" />
        <label htmlFor="sort" className="text-black font-medium">
          SORT BY
        </label>
      </div>

      {/* Filter Section */}
      <div
        className="flex items-center gap-2 cursor-pointer"
        onClick={handleFilterClick} // Open DateTimeFilter modal on click
      >
        <FaFilter className="text-xl text-black" />
        <label htmlFor="filter" className="text-black font-medium">
          FILTER
        </label>
      </div>

      {/* Render the DateTimeFilter modal if it's open */}
      {isFilterOpen && (
        <div className="fixed inset-0 bg-gray-500 bg-opacity-50 flex justify-center items-center z-50">
          <div className="bg-white  rounded-lg shadow-lg w-full h-full max-w-md">
            <MDateTimeFilter closeModal={closeFilterModal} />
          </div>
        </div>
      )}

      {/* Render the SortBy modal if it's open */}
      {isSortByOpen && (
        <MSortBy closeModal={() => setIsSortByOpen(false)} />
      )}
    </div>
  );
};

export default MSortAndFilter;
